import React from 'react'
import Component from '../common/Component'
import CriticalIllnessBenefitsSetComponent from './CriticalIllnessBenefitsSetComponent'
import { benefitNames } from './criticalIllnessFields'
import BenefitsSetForm from '../BenefitsSet/BenefitsSetForm'

export default class CriticalIllnessBenefitsSetForm extends Component {
  render() {
    return (
      <BenefitsSetForm
        benefitNames={benefitNames}
        benefitsSetComponent={CriticalIllnessBenefitsSetComponent}
        productLine="Critical Illness"
        {...this.props}
      />
    )
  }
}
